<template>
  <div class="header-bar">
    <slot name="logo"></slot>
    <slot name="project"></slot>
    <custom-bread-crumb show-icon :list="breadCrumbList"></custom-bread-crumb>
    <div class="custom-content-con">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import customBreadCrumb from './custom-bread-crumb'

export default {
  name: 'HeaderBar',
  components: {
    customBreadCrumb
  },
  computed: {
    breadCrumbList () {
      return this.$store.state.app.breadCrumbList
    }
  },
}
</script>
